<template>
  <slot :links />
</template>

<script setup>
import { useBreadcrumb } from "#imports";
const links = useBreadcrumb();
defineSlots();
</script>
